import React from 'react';
import { BikShimmer } from '@bikdotai/bik-component-library';

const EditMacroModalShimmer: React.FC = () => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
      {/* Macro Name: label + input + hint */}
      <BikShimmer
        boxes={[
          { height: '14px', width: '120px' },
          { height: '40px', width: '100%' },
          { height: '12px', width: '80px' },
        ]}
      />

      {/* Description: label + multiline input + hint */}
      <BikShimmer
        boxes={[
          { height: '14px', width: '100px' },
          { height: '96px', width: '100%' },
          { height: '12px', width: '80px' },
        ]}
      />

      {/* Visibility: label + dropdown */}
      <BikShimmer
        boxes={[
          { height: '14px', width: '80px' },
          { height: '40px', width: '100%' },
        ]}
      />
    </div>
  );
};

export default EditMacroModalShimmer;
